<div class="gallery-card" [ngClass]="{'gallery-card--checked': checked}" (click)="handleSelect(result)">
  <div class="gallery-card__image-container">

    <div class="gallery-card__image"
      *ngIf="result.thumbnail_url"
      [ngStyle]="{'background-image': 'url(' + result.thumbnail_url + ')'}">
    </div>

    <div class="gallery-card__hover hide-sm">
      <div class="gallery-card__meta">
        <div *ngIf="hasColumn(galleryColumns.CreatedBy) && result.author">Created by {{ result.author_first_name || result.author }}</div>
        <div *ngIf="hasColumn(galleryColumns.UpdatedBy) && result.last_editor">Updated by {{ result.last_editor_first_name || result.last_editor }} on {{ (result.update_date_time || result.create_date_time) | date:'shortDate' }}</div>
      </div>

      <div class="gallery-card__action">
        {{ selectLabel }}
      </div>

      <div class="gallery-card__header" appEventFence>
        <div
          class="gallery-card__check theme-ghost" 
          [class.card__check--checked]="checked"
          *ngIf="checkable">
          <mat-checkbox (change)="handleCheckedChange($event)" [value]="result.id" [checked]="checked"></mat-checkbox>
        </div>
      </div>
    </div>
  </div>
  
  <div class="gallery-card__body">
    <div class="gallery-card__actions hide-sm" appEventFence>
      <ng-container *ngTemplateOutlet="galleryActionsTemplate; context: { $implicit: result }"></ng-container>
    </div>

    <div class="gallery-card__label">{{ result.title }}</div>

    <div class="text-10 text-uppercase text-medium text-dim mt-2">
      <ng-container *ngTemplateOutlet="galleryTagsTemplate; context: { $implicit: result }"></ng-container>
    </div>
  </div>
</div>